export default {
  tiny: 10,
  small: 12,
  medium: 14,
  large: 16,
  huge: 18,
  massive: 32,
}



// WEBPACK FOOTER //
// ./src/components/styles/fontSizes.js